import { forwardRef } from 'react';
import type { PolymorphicComponentPropWithRef, PolymorphicRef } from '../types';
import clsx from 'clsx';
import styles from './text.module.css';

export type TextProps<As extends React.ElementType = 'p'> =
  PolymorphicComponentPropWithRef<
    As,
    {
      size?: 'inherit' | 'body' | 'lead' | 'large' | 'small';
      weight?: '400' | '500' | '700' | 400 | 500 | 700;
    }
  >;

type TextComponent = <As extends React.ElementType = 'p'>(
  props: TextProps<As>
) => JSX.Element;

export const Text: TextComponent = forwardRef(function Text<
  As extends React.ElementType = 'p'
>(
  { as, className, size = 'inherit', weight = 400, ...rest }: TextProps<As>,
  ref?: PolymorphicRef<As>
) {
  const Tag = as || 'p';
  const classes = clsx(
    className,
    styles.text,
    styles[size],
    styles[`weight-${weight}`]
  );

  return <Tag className={classes} ref={ref} {...rest} />;
}) as TextComponent;
